import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextareaDrag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTextareaDrag"><Path d="M14.25 21.7494L21.75 14.2344" stroke="currentColor"/><Path d="M6.25 21.75L21.75 6.25" stroke="currentColor"/></CentralIconBase>;
});

export default IconTextareaDrag;
